/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import {
  ActivityLog,
  ActivityLogResourceMapping,
  ActivityLogResources
} from '../../../../ts/activity-log';
import { capitalizeFirstLetter } from '../../util/string';

export const renderActivityLogItem = (log: ActivityLog): string => {
  let item: string;
  if (log._tooling_item === ActivityLogResources.DIALOG) {
    item = ActivityLogResourceMapping.DIALOG;
  } else if (log._tooling_item === ActivityLogResources.ASSISTANT) {
    item = ActivityLogResourceMapping.ASSISTANT;
  } else if (log._tooling_item === ActivityLogResources.DATA_TYPE) {
    item = ActivityLogResourceMapping.DATA_TYPE;
  } else {
    item = capitalizeFirstLetter(log._tooling_item);
  }
  return item;
};
